export const TransactionTypes = {
  MONTHLY_SUBSCRIPTION_FEE: 'MONTHLY_SUBSCRIPTION_FEE',
  LAUNCH_FEE: 'LAUNCH_FEE',
  SELL_FEE: 'SELL_FEE',
  BUY_FEE: 'BUY_FEE',
};

export const TransactionTypeLabels = {
  [TransactionTypes.MONTHLY_SUBSCRIPTION_FEE]: 'Monthly subscription fee',
  [TransactionTypes.LAUNCH_FEE]: 'Fee for launch',
  [TransactionTypes.SELL_FEE]: 'Fee for selling',
  [TransactionTypes.BUY_FEE]: 'Fee for buying',
};

export const TransactionTypeOptions = [
  { value: null, label: 'All' },
  {
    value: TransactionTypes.MONTHLY_SUBSCRIPTION_FEE,
    label: TransactionTypeLabels[TransactionTypes.MONTHLY_SUBSCRIPTION_FEE],
  },
  {
    value: TransactionTypes.LAUNCH_FEE,
    label: TransactionTypeLabels[TransactionTypes.LAUNCH_FEE],
  },
  {
    value: TransactionTypes.SELL_FEE,
    label: TransactionTypeLabels[TransactionTypes.SELL_FEE],
  },
  {
    value: TransactionTypes.BUY_FEE,
    label: TransactionTypeLabels[TransactionTypes.BUY_FEE],
  },
];
